/**
 * Example JavaScript singleton module
 */

var Language = (function($) {

  function initLanguage() {
    // do something
    let currentLanguageLink = $('.wpml-ls-current-language > a');
    if ($(window).width() > 900){
        // do stuff
        currentLanguageLink.click(function(e){
        e.preventDefault();
        //currentLanguageLink.next('.sub-menu').show();
        currentLanguageLink.parent().toggleClass('wpml-ls-current-language--opened')
    });
    }
    
  }

  function init() {

    // return early if no corresponding module present
    if (!$('.wpml-ls-menu-item').length) {
      return;
    }

    initLanguage();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Language.init);
